"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LazyBackgroundImage;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useImageLoading = require("../hooks/use-image-loading.js");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const ImageContainerDiv = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImageContainerDiv",
  class: "core-iymqaaq",
  vars: {
    "iymqaaq-0": [({
      portrait
    }) => portrait ? `url(${portrait})` : 'initial'],
    "iymqaaq-2": [({
      tablet
    }) => tablet ? `url(${tablet})` : 'initial'],
    "iymqaaq-4": [({
      landscape
    }) => landscape ? `url(${landscape})` : 'initial']
  }
});
const ImageContainerSection = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "ImageContainerSection",
  class: "core-i1o7m030",
  vars: {
    "i1o7m030-0": [({
      portrait
    }) => portrait ? `url(${portrait})` : 'initial'],
    "i1o7m030-2": [({
      tablet
    }) => tablet ? `url(${tablet})` : 'initial'],
    "i1o7m030-4": [({
      landscape
    }) => landscape ? `url(${landscape})` : 'initial']
  }
});

/**
 * LazyBackgroundImage
 *
 * @param {Object} props props
 * @param {string} props._name The tracking name for the component
 * @param {string} props.dataCy Override data-cy
 * @param {String} props.landscape Image Source for landscape orientation and will be used as default in all other situations
 * @param {String} props.portrait Image Source for portrait orientation
 * @param {String} props.elementType Type of html element (div, section)
 * @param {String} props.breakOn Break on Mobile
 * @param {String} props.imgLoading Lazy loading control: eager or lazy.
 * @returns {React.ReactFragment} LazyImage Component
 * @public
 */

function LazyBackgroundImage({
  _name,
  portrait,
  tablet,
  landscape,
  elementType = 'div',
  breakOn,
  style,
  className,
  imgLoading = 'lazy',
  dataCy = 'image',
  isPromo = true,
  ...rest
}) {
  const {
    ref,
    shouldLoad
  } = (0, _useImageLoading.useImageLoading)({
    loading: imgLoading,
    rootMargin: '200px 0px',
    threshold: 0,
    initialInView: false
  });
  _patternLibraryUtils.tracking.useTracking(ref);
  const trackingProps = _patternLibraryUtils.tracking.props(_name, false, isPromo);
  const bgClass = shouldLoad ? 'lazy-bg apply-bg' : 'lazy-bg';
  const ImageContainer = elementType === 'section' ? ImageContainerSection : ImageContainerDiv;
  return /*#__PURE__*/_react.default.createElement(ImageContainer, (0, _extends2.default)({
    className: `${bgClass} ${className}`,
    ref: ref,
    inView: shouldLoad,
    portrait: portrait,
    tablet: tablet ?? landscape,
    landscape: landscape,
    "data-breakpoint": breakOn,
    "data-cy": dataCy,
    style: {
      ...style
    }
  }, trackingProps, rest));
}
LazyBackgroundImage.propTypes = {
  _name: _propTypes.default.string,
  portrait: _propTypes.default.string,
  tablet: _propTypes.default.string,
  landscape: _propTypes.default.string,
  elementType: _propTypes.default.oneOf(['div', 'section']),
  breakOn: _propTypes.default.oneOf(['mobile', 'ipadPro']),
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  imgLoading: _propTypes.default.oneOf(['lazy', 'eager']),
  dataCy: _propTypes.default.string,
  isPromo: _propTypes.default.bool
};